import {ReactComponent as CheckmarkIcon} from "@assets/icons/checkmark.svg";

const SelectedCheckmark = () => {
    return (
        <div className="w-[20px] h-[20px] min-w-[20px] flex justify-center items-center rounded-full bg-inherit">
            <CheckmarkIcon className="w-[10px] h-[10px] !stroke-[3] text-white"/>
        </div>
    )
}

export default SelectedCheckmark
